<template>
  <ul class="sub-level-list">
    <li
      v-for="permission in permissions"
      :key="permission.name"
    >
      <b-form-checkbox
        v-model="user.permissions[permission.name]"
        :class="permissionItemClass"
        :disabled="shouldDisablelItem(permission.name)"
        @change="onChangeSelectionHandler($event, permission.name)"
      >
        {{ $t(`permissions.codes.${permission.name}`) }}
      </b-form-checkbox>

      <div v-if="permission.children && permission.children.length">
        <permission-items
          :user="user"
          :permissions="permission.children"
          :superior-permission="permission.name"
          :is-disabled="shouldDisablelItem(permission.name)"
        />
      </div>
    </li>
  </ul>
</template>

<script>
import eventBus from '@/services/globalEventBus';
import events from '@/domain/events/userPermissions';
import UserService from '@/services/user';

export default {
  name: 'permission-items',
  props: {
    user: Object,
    permissions: Array,
    superiorPermission: {
      type: String,
      default: '',
    },
    isDisabled: {
      type: Boolean,
      default: null,
    },
  },
  computed: {
    isSubLevelItem() {
      return !!this.superiorPermission;
    },
    permissionItemClass() {
      return this.isSubLevelItem ? 'sub-level-item' : '';
    },
  },
  methods: {
    shouldDisablelItem(permission) {
      if (this.isDisabled) {
        return true;
      }

      if (!UserService.hasPermission(permission)) {
        return true;
      }

      return !!(this.isSubLevelItem && !this.user.permissions[this.superiorPermission]);
    },
    onChangeSelectionHandler(event, permissionName) {
      eventBus.emit(events.onChangePermissionItem);
      this.updatePermissionsSelection(event, permissionName);
    },
    updatePermissionsSelection(event, permissionName) {
      if (event) {
        return;
      }

      const [permission] = this.permissions.filter(x => x.name === permissionName);
      const permissionChildren = permission?.children || [];

      permissionChildren.forEach((child) => {
        this.user.permissions[child.name] = false;
      });
    },
  },
};
</script>

<style lang="sass" scoped>
.sub-level
  &-list
    list-style: none
    padding-left: 0
    margin-bottom: 0
  &-item
    padding-left: 3rem
</style>
